module.exports = __webpack_public_path__ + "img/9001.5d33f2d6.png";